import { ContactManagementConfigContext } from '../../../../ui/providers';
import React from 'react';
import { useDefaultAdvancedSearchItems } from './useDefaultAdvancedSearchItems';
/**
 * Returns final advanced search items that were customized through ContactManagementConfigContext.
 */
export function useResolvedAdvancedSearchItems() {
    const { accountsTableCustomization } = React.useContext(ContactManagementConfigContext);
    const defaultAdvancedSearchItems = useDefaultAdvancedSearchItems();
    return (accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.onGetAdvancedSearchItems)
        ? accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.onGetAdvancedSearchItems(defaultAdvancedSearchItems)
        : defaultAdvancedSearchItems;
}
